import { createBrowserRouter, Navigate } from 'react-router-dom';
import { PluvaIonLandingPage } from '../pages/PluvaIonLandingPage/PluvaIonLandingPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to='/introduce' replace />,
  },
  {
    path: '/introduce',
    element: <PluvaIonLandingPage />,
  },
]);
